import * as API from '../api'
export const FETCH_MEDICATION = 'FETCH_MEDICATION'
export const FETCHING_MEDICATION = 'FETCHING_MEDICATION'
export const FETCH_MEDICATION_ERROR = 'FETCH_MEDICATION_ERROR'
export const FETCH_MEDICATIONS = 'FETCH_MEDICATIONS'
export const FETCHING_MEDICATIONS = 'FETCHING_MEDICATIONS'
export const FETCH_MEDICATIONS_ERROR = 'FETCH_MEDICATIONS_ERROR'
export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const CHANGE_MEDICATION = 'CHANGE_MEDICATION'
export const DELETE_MEDICATION = 'DELETE_MEDICATION'
export const ADD_MEDICATION = 'ADD_MEDICATION'
export const EDIT_MEDICATION = 'EDIT_MEDICATION'
export const FORM_TOUCHED = 'FORM_TOUCHED'
export const NEW_FORM_MEDICATION = 'NEW_FORM_MEDICATION'
export const MEDICATION_FORM_ERROR = 'MEDICATION_FORM_ERROR'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CHANGE_PER_PAGE = 'CHANGE_PER_PAGE'
export const CHANGE_ORDER_COLUMN = 'CHANGE_ORDER_COLUMN'
export const CHANGE_ORDER_DIRECTION = 'CHANGE_ORDER_DIRECTION'
export const RESET_STATE = 'RESET_STATE'

export const openModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_MODAL })
  }
}

export const handleChangeMedication = medication => {
  return dispatch => {
    dispatch({ type: CHANGE_MEDICATION, medication })
  }
}

const getDuplicateKeyField = errorMessage => {
  const [x, field = ''] = /collection: .* index: (.*)_/.exec(errorMessage) // eslint-disable-line
  return field
}

export const handleMedicationError = (res, dispatch) => {
  const { data: errorMessage = '' } = res

  switch (true) {
    case errorMessage.includes('duplicate key error'):
      dispatch({
        type: FORM_TOUCHED
      })
      dispatch({
        type: MEDICATION_FORM_ERROR,
        field: getDuplicateKeyField(errorMessage),
        message: `${getDuplicateKeyField(errorMessage)} já cadastrado.`
      })
      return Promise.reject(res)

    default:
      break
  }
}

export const newFormMedication = medication => {
  return dispatch => {
    dispatch({ type: NEW_FORM_MEDICATION })
  }
}

export const setMedicationFormTouched = medication => {
  return dispatch => {
    dispatch({ type: FORM_TOUCHED })
  }
}

export const closeModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_MODAL })
  }
}

export const restoreMedication = id => {
  return dispatch => {
    dispatch({ type: FETCHING_MEDICATIONS })
    return API.medications
      .restoreMedication(id)
      .then(({ data }) => {
        dispatch({ type: EDIT_MEDICATION, medication: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_MEDICATIONS_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleMedicationError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const handleChangePage = page => {
  return dispatch => {
    dispatch({ type: CHANGE_PAGE, page })
  }
}

export const handleChangePerPage = perPage => {
  return dispatch => {
    dispatch({ type: CHANGE_PER_PAGE, perPage })
  }
}

export const changeOrderColumn = column => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_COLUMN, column })
  }
}

export const changeOrderDirection = direction => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_DIRECTION, direction })
  }
}

export const resetState = () => {
  return dispatch => {
    dispatch({ type: RESET_STATE })
  }
}

export const fetchMedications = options => {
  return dispatch => {
    dispatch({ type: FETCHING_MEDICATIONS })
    return API.medications
      .getMedications(options)
      .then((res = {}) => {
        const { data } = res
        dispatch({
          type: FETCH_MEDICATIONS,
          medications: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_MEDICATIONS_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const deleteMedication = id => {
  return dispatch => {
    dispatch({ type: FETCHING_MEDICATIONS })
    return API.medications
      .deleteMedication(id)
      .then(({ data: medication }) => {
        dispatch({ type: DELETE_MEDICATION, medication })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_MEDICATIONS_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const addMedication = medication => {
  return dispatch => {
    dispatch({ type: FETCHING_MEDICATIONS })
    dispatch({ type: FETCHING_MEDICATION })
    return API.medications
      .addMedication(medication)
      .then(({ data }) => {
        dispatch({ type: ADD_MEDICATION, medication: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        handleMedicationError(response, dispatch)
        dispatch({
          type: FETCH_MEDICATIONS_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const editMedication = medication => {
  return dispatch => {
    dispatch({ type: FETCHING_MEDICATIONS })
    dispatch({ type: FETCHING_MEDICATION })
    return API.medications
      .editMedication(medication)
      .then(({ data }) => {
        dispatch({ type: EDIT_MEDICATION, medication: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_MEDICATIONS_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleMedicationError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const fetchMedication = id => {
  return dispatch => {
    dispatch({ type: FETCHING_MEDICATION, clear: true })
    dispatch({ type: OPEN_MODAL })
    return API.medications
      .getMedication(id)
      .then(({ data }) => {
        dispatch({ type: FETCH_MEDICATION, medication: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_MEDICATION_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/medications.js